import { Directive, Input } from '@angular/core';

import { RxntFormGroupService } from './rxnt-form-group.service';

@Directive({
  selector: '[rxntFormGroup]',
  exportAs: 'rxntFormGroup',
  standalone: false,
  providers: [ RxntFormGroupService ],
})
export class RxntFormGroupDirective {
  @Input() set reserveSpaceForError(value: boolean) {
    this.service.reserveSpaceForError = value;
  }

  @Input() set isRequired(value: boolean) {
    this.service.isRequired = value;
  }

  @Input() set isRequiredMessage(value: string) {
    this.service.isRequiredMessage = value;
  }

  constructor(private service: RxntFormGroupService) {
  }

  validateAll(): void {
    this.service.validateAll();
  }

  resetValidation(): void {
    this.service.resetValidation();
  }
}
